import { mainMenu } from "./components/menu";
import { initDropdown } from "./components/dropdown";
import { faqFn } from "./components/faq";
import { headerScroll } from "./components/header";
import {
  hideNavOnFooter,
  staticHeroHeaderTheme,
  bestsellersParallaxHeading,
  homeNav,
} from "./components/home";
import { handleWooCommerceNotices } from "./components/notices";
import {
  ProductMiniatureGallerySlider,
  refreshSlider,
  SimpleCategories,
  AboutFeaturesSlider,
  AboutGallerySlider,
  MaterialCloseUpSliders,
  DontForgetToAddToCartSlider,
  completeProductsSlider,
  relatedProductsSlider,
  plantTreeHowItWorksSlider,
  homeHeroSlider,
  upSellProductsSlider,
  loadHomeSliders,
  HomeBestsellersSlider,
  blogBestsellersSlider,
  productCardCertificatesSlider,
  landingProductsSlider,
  landingProductsSliderLg,
  landingProductsSliderGrid,
  productGallerySlider,
} from "./components/sliders";
import { setupQuantityControls, setupAddonQuantityToggle } from "./woocommerce/quantity-input";
import { setupCartAutoUpdate } from "./woocommerce/cart-auto-update";
import { setupWapoPopupErrorNotice } from "./woocommerce/wapo-popup-error";
import { setupSidePanelSizes } from "./yith-woocommerce-color-label-variations-premium/side-panel-sizes";
import { addDescriptionToImageAttribute } from "./yith-woocommerce-color-label-variations-premium/add-description-to-image-attribute";
import { preventAttributeDeselect } from "./yith-woocommerce-color-label-variations-premium/prevent-attribute-deselect";
import { subMenu } from "./components/submenu";
import { seoTextAccordion } from "./components/seoText";
import { searchBar } from "./components/search";
import { marquee } from "./components/marquee";
import { customSelectInit } from "./components/customSelect";
import { lazyLoadVideo } from "./components/lazyVideo";
import { authNavigationHanlder } from "./woocommerce/auth";

import { dimensionTableHandler } from "./woocommerce/dimension-table";
import { customAside } from "./woocommerce/custom-aside";

import { updateVariationUrl } from "./woocommerce/update-variation-url";
import { tabs } from "./components/tabs";
import { productDetailsAccordion } from "./woocommerce/product-details-accordion";
import { updateProductPrice } from "./woocommerce/product-card-update-price";
import { wishlistFn } from "./components/wishlist";
import { additionalPriceInfo } from "./woocommerce/additional-price-info";
import { updateVariationEan } from "./woocommerce/update-variation-ean";
import { updateVariationBadges } from "./woocommerce/update-variation-badges";
import { updatePriceBlockPromo } from "./woocommerce/update-price-block-promo";
import { tableOfContents } from "./components/tableOfContents";
import { initReassurance } from "./components/block-reassurance";
import { initModals } from "./components/custom-modal";
import { informationAfterSelectCountry } from "./woocommerce/information-after-select-country";
import { handleCopyButtons, initBannerCodeCopy } from "./components/copy-code";
import { handleTopbarPromo } from "./components/handleTopBarPromo";
import {setupProductAvailableImmediately} from "./woocommerce/product-available-immediately";
import { initAjaxProducts } from "./components/ajax-products";
import { initLazyWishlist } from "./woocommerce/wishlist-lazy";
import { initNavbarAccountLazy } from "./components/navbar-account";
import { initNavbarCartLazy } from "./components/navbar-cart";
import { setupAddToCartLoading } from "./woocommerce/add-to-cart-loading";
import { setupAddedToCartPopup } from "./woocommerce/added-to-cart-popup";
import { setupFloatingAddToCart } from "./woocommerce/floating-add-to-cart";
import { fitProductColorSwatches } from "./woocommerce/product-color-swatches";
import { lazyLoadImages } from "./components/lazyImage";

const refreshFsLightboxSafely = () => {
  if (typeof refreshFsLightbox !== "function") return;

  const instances = window.fsLightboxInstances || {};
  Object.keys(instances).forEach((key) => {
    const props = instances[key]?.props;
    if (!props) return;
    props.thumbs = [];
    props.types = [];
    props.captions = [];
    props.autoplays = [];
    props.customAttributes = [];
  });

  refreshFsLightbox();
};

document.addEventListener("DOMContentLoaded", () => {
  const isHomePage = document.querySelector("body.home");
  const isContactPage = document.querySelector("body.page-template-contact");
  const isFaqPage = document.querySelector("body.page-template-faq");
  const isCartPage = document.querySelector("body.woocommerce-cart");
  const isShop = document.querySelector("body.woocommerce-shop");
  const isCheckoutPage = document.querySelector(
    "body.woocommerce-checkout-page",
  );
  const isSingleProductPage = document.querySelector("body.single-product");
  const isWoocommerceProductCategory = document.querySelector(
    ".woocommerce-product-category",
  );
  const isWoocommerceAccount = document.querySelector(".woocommerce-account");
  const isAboutPage = document.querySelector("body.page-template-about");
  const isAboutMaterialPage = document.querySelector(
    "body.page-template-about-material",
  );
  const isPlantTree = document.querySelector("body.page-template-plant-tree");
  const isArticle = document.querySelector("body.single-post");
  const isNotFoundPage = document.querySelector("body.error404");
  // .sbw-page: landing Black Week z seba-early-access (te same karty produktów i slidery)
  const isPromoLandingPage = document.querySelector(
    "body.page-template-promotion-lp, body.sbw-page",
  );

  lazyLoadImages();

  // if (!isShop && !isWoocommerceProductCategory) {
  mainMenu();
  subMenu();
  // }
  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(() => { headerScroll(); ticking = false; });
      ticking = true;
    }
  });

  fitProductColorSwatches();
  let resizeTicking = false;
  window.addEventListener("resize", () => {
    if (!resizeTicking) {
      requestAnimationFrame(() => {
        fitProductColorSwatches();
        resizeTicking = false;
      });
      resizeTicking = true;
    }
  });

  initDropdown();
  initNavbarAccountLazy();
  initNavbarCartLazy();
  handleWooCommerceNotices();
  initModals();
  handleCopyButtons();
  initBannerCodeCopy();
  // handleTopbarPromo();
  const initInspirationScrollLock = () => {
    const inst = window.fsLightboxInstances?.["inspirations"];
    if (!inst) return;
    inst.props.onOpen = () => {
      document.documentElement.classList.add("no-scroll");
    };
    inst.props.onClose = () => {
      document.documentElement.classList.remove("no-scroll");
    };
  };

  if (isHomePage) {
    homeNav();
    hideNavOnFooter();
    bestsellersParallaxHeading();
    homeHeroSlider();
    initInspirationScrollLock();
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadHomeSliders, { timeout: 1500 });
    } else {
      loadHomeSliders();
    }

  
    customAside();
    setupQuantityControls();
    setupSidePanelSizes();
    setupProductAvailableImmediately();
  }
  if (isContactPage || isFaqPage || isArticle || isAboutMaterialPage) {
    faqFn();
  }

  if (isWoocommerceProductCategory || isShop || isSingleProductPage) {
    initLazyWishlist();
  }

  if (isSingleProductPage || isWoocommerceProductCategory || isShop) {
    preventAttributeDeselect();
    setupSidePanelSizes();
    setupProductAvailableImmediately();
    additionalPriceInfo();
    updateVariationBadges();

    jQuery(document).on("yith_wccl_product_gallery_loaded", function () {
      refreshFsLightboxSafely();
      if (isSingleProductPage) productGallerySlider();
    });
  }

  if (isCheckoutPage) {
    informationAfterSelectCountry();
  }

  setupAddToCartLoading();
  setupAddedToCartPopup();
  setupQuantityControls();
  setupAddonQuantityToggle();
  setupWapoPopupErrorNotice();

  if (isSingleProductPage) {
    updateProductPrice();
    updatePriceBlockPromo();

    ProductMiniatureGallerySlider();
    completeProductsSlider();
    customAside();
    dimensionTableHandler();
    tabs();
    productDetailsAccordion();
    initAjaxProducts();
    productGallerySlider();

    updateVariationUrl();
    updateVariationEan();
    initReassurance();
    productCardCertificatesSlider();
    setupFloatingAddToCart();
  }
  if (isCartPage) {
    updateVariationBadges();
    setupCartAutoUpdate();
    DontForgetToAddToCartSlider();
    ProductMiniatureGallerySlider();
    customAside();
    addDescriptionToImageAttribute();
    setupSidePanelSizes();
    setupProductAvailableImmediately();
    jQuery(document).on("yith_wccl_product_gallery_loaded", function () {
      refreshFsLightboxSafely();
    });
  }
  if (isShop || isWoocommerceProductCategory) {
    jQuery(".yith-wcan-filter[data-filter-type='availability']")
      .on("yith_wcan_is_filter_active", function () {
        return jQuery(this).find(".filter-item").hasClass("active");
      })
      .on("yith_wcan_filter_properties", function (ev, properties) {
        properties.availability_filter = "1";
        return properties;
      });

    jQuery(document).on("yith_wcan_supported_filters_parameters", function (ev, params) {
      params.push("availability_filter");
      return params;
    });

    SimpleCategories();
    ProductMiniatureGallerySlider();
    customSelectInit();
    customAside();

    jQuery(document).on("yith-wcan-ajax-filtered", function () {
      refreshSlider("splide--simple-categories", SimpleCategories);
      refreshSlider(
        "splide--product-thumbnail-slider",
        ProductMiniatureGallerySlider,
      );
      mainMenu();
      subMenu();
      // seoTextAccordion();
      customSelectInit();

      addDescriptionToImageAttribute();
      setupSidePanelSizes();
      setupProductAvailableImmediately();
      fitProductColorSwatches();
    });
  }
  if (isAboutPage) {
    AboutFeaturesSlider();
    AboutGallerySlider();
  }
  if (isAboutMaterialPage) {
    MaterialCloseUpSliders();
  }
  if (isWoocommerceAccount) {
    authNavigationHanlder();
  }
  if (isPlantTree) {
    plantTreeHowItWorksSlider();
    staticHeroHeaderTheme();
  }
  if (isNotFoundPage) {
    HomeBestsellersSlider();
  }
  if (isArticle) {
    tableOfContents();
    setupSidePanelSizes();
    customAside();
    setupProductAvailableImmediately();
    blogBestsellersSlider();
    ProductMiniatureGallerySlider();
    updateVariationBadges();
  }
  if (isPromoLandingPage) {
    landingProductsSlider();
    ProductMiniatureGallerySlider();
    landingProductsSliderLg();
    landingProductsSliderGrid();
    customAside();
    dimensionTableHandler();
    setupSidePanelSizes();
    setupProductAvailableImmediately();
    updateVariationBadges();
    jQuery(document).on("yith_wccl_product_gallery_loaded", function () {
      refreshFsLightboxSafely();
    });
  }
  seoTextAccordion();
  searchBar();
  marquee();
  lazyLoadVideo();
  addDescriptionToImageAttribute();
  wishlistFn();

  // Colourweek

  const specialOfferColors = [
    "#EEA466",
    "#EA8A7A",
    "#D9633F",
    "#F3BB55",
    "#7D9BA3",
    "#F3BB55",
    "#EEA466",
    "#EA8A7A",
    "#D9633F",
    "#7D9BA3",
  ];

  const title = document.querySelector("#navigation .isColourweek a");
  if (title) {
    const text = title.textContent.trim();
    title.innerHTML = ""; //

    [...text].forEach((char, i) => {
      const span = document.createElement("span");
      span.textContent = char;
      span.style.color = specialOfferColors[i % specialOfferColors.length];
      title.appendChild(span);
    });
  }
});
